require('../public/css/bootstrap.min.css')
require('../public/css/navbari.css')
require('../public/css/bootstrap-social.css')
require('../public/css/header-v8.css')
require('../public/css/form.css')
require('../public/font-awesome/css/font-awesome.min.css')

var FormatMessage = require('react-globalize').FormatMessage;

var React = require('react');
var ReactDOM = require('react-dom');
var Link = require('react-router').Link;

var BfgNavBar = React.createClass({

  handleHeader: function () {

    $(window).scroll(function () {
      if ($(window).scrollTop() > 100) {
        $('.header-fixed .header-sticky').addClass('header-fixed-shrink');
      } else {
        $('.header-fixed .header-sticky').removeClass('header-fixed-shrink');
      }
    });
  },

  handleMegaMenu: function () {
    $(document).on('click', '.mega-menu .dropdown-menu', function (e) {
      e.stopPropagation();
    })
  },

  handleSearch: function () {
    $('.search').on("click", function () {
      if ($('.search-btn').hasClass('fa-search')) {
        $('.search-open').fadeIn(500);
        $('.search-btn').removeClass('fa-search');
        $('.search-btn').addClass('fa-times');
      } else {
        $('.search-open').fadeOut(500);
        $('.search-btn').addClass('fa-search');
        $('.search-btn').removeClass('fa-times');
      }
    });
  },

  handleSearchV1: function () {
    $('.header-v5 .search-button').click(function () {
      $('.header-v5 .search-open').slideDown();
    });

    $('.header-v5 .search-close').click(function () {
      $('.header-v5 .search-open').slideUp();
    });

    $(window).scroll(function () {
      if ($(this).scrollTop() > 1) $('.header-v5 .search-open').fadeOut('fast');
    });
  },

  handleSearchV2: function () {
    $(".blog-topbar .search-btn").on("click", function () {
      if ($(".topbar-search-block").hasClass("topbar-search-visible")) {
        $(".topbar-search-block").slideUp();
        $(".topbar-search-block").removeClass("topbar-search-visible");
      } else {
        $(".topbar-search-block").slideDown();
        $(".topbar-search-block").addClass("topbar-search-visible");
      }
    });
    $(".blog-topbar .search-close").on("click", function () {
      $(".topbar-search-block").slideUp();
      $(".topbar-search-block").removeClass("topbar-search-visible");
    });
    $(window).scroll(function () {
      $(".topbar-search-block").slideUp();
      $(".topbar-search-block").removeClass("topbar-search-visible");
    });
  },

  handleTopBar: function () {

    $(".topbar-toggler").on("click", function () {
      if ($(".topbar-toggler").hasClass("topbar-list-visible")) {
        $(".topbar-menu").slideUp();
        $(this).removeClass("topbar-list-visible");
      } else {
        $(".topbar-menu").slideDown();
        $(this).addClass("topbar-list-visible");
      }
    });
  },
  handleTopBarSubMenu: function () {

    $(".topbar-list > li").on("click", function (e) {
      if ($(this).children("ul").hasClass("topbar-dropdown")) {
        if ($(this).children("ul").hasClass("topbar-dropdown-visible")) {
          $(this).children(".topbar-dropdown").slideUp();
          $(this).children(".topbar-dropdown").removeClass("topbar-dropdown-visible");
        } else {
          $(this).children(".topbar-dropdown").slideDown();
          $(this).children(".topbar-dropdown").addClass("topbar-dropdown-visible");
        }
      }

    });
  },
  handleToggle: function () {
    $('.list-toggle').on('click', function () {
      $(this).toggleClass('active');
    });
  },
  handleEqualHeightColumns: function () {
    var EqualHeightColumns = function () {
      $(".equal-height-columns").each(function () {
        heights = [];
        $(".equal-height-column", this).each(function () {
          $(this).removeAttr("style");
          heights.push($(this).height()); // write column's heights to the array
        });
        $(".equal-height-column", this).height(Math.max.apply(Math, heights)); //find and set max
      });
    }

    EqualHeightColumns();
    $(window).resize(function () {
      EqualHeightColumns();
    });
    $(window).load(function () {
      EqualHeightColumns("img.equal-height-column");
    });
  },

  handleFullscreen: function () {
    var WindowHeight = $(window).height();
    var HeaderHeight;

    if ($(document.body).hasClass("promo-padding-top")) {
      HeaderHeight = $(".header").height();
    } else {
      HeaderHeight = 0;
    }

    $(".fullheight").css("height", WindowHeight - HeaderHeight);

    $(window).resize(function () {
      var WindowHeight = $(window).height();
      $(".fullheight").css("height", WindowHeight - HeaderHeight);
    });
  },

  handleValignMiddle: function () {
    $(".valign__middle").each(function () {
      $(this).css("padding-top", $(this).parent().height() / 2 - $(this).height() / 2);
    });
    $(window).resize(function () {
      $(".valign__middle").each(function () {
        $(this).css("padding-top", $(this).parent().height() / 2 - $(this).height() / 2);
      });
    });
  },

  handleHoverSelector: function () {
    // $('.hoverSelector').on('hover', function(e) {
    // 	$('.hoverSelectorBlock', this).toggleClass('show');
    // 	e.stopPropagation();
    // });
    $('.hoverSelector').on('click', function (e) {
      if ($(this).children('ul').hasClass('languages')) {
        if ($(this).children('ul').hasClass('languages-visible')) {
          $(this).children('.languages').slideUp();
          $(this).children('.languages').removeClass('languages-visible');
        } else {
          $(this).children('.languages').slideDown();
          $(this).children('.languages').addClass('languages-visible');
        }
      }
      //e.preventDefault();
    })
  },
  //Bootstrap Tooltips and Popovers
  handleBootstrap: function () {

    /*Popovers*/
    $('.popovers').popover();
    $('.popovers-show').popover('show');
    $('.popovers-hide').popover('hide');
    $('.popovers-toggle').popover('toggle');
    $('.popovers-destroy').popover('destroy');
  },

  initCounter: function () {
    $('.counter').counterUp({
      delay: 10,
      time: 1000
    });
  },

  //Parallax Backgrounds
  initParallaxBg: function () {
    $(window).load(function () {
      $('.parallaxBg').parallax("50%", 0.2);
      $('.parallaxBg1').parallax("50%", 0.4);
    });
  },

  //Scroll Bar
  initScrollBar: function () {
    $('.mCustomScrollbar').mCustomScrollbar({
      theme: "minimal",
      scrollInertia: 200,
      scrollEasing: "linear"
    });
  },

  // Sidebar Menu Dropdown
  initSidebarMenuDropdown: function () {
    function SidebarMenuDropdown() {
      $('.header-v7 .dropdown-toggle').on('click', function () {
        $('.header-v7 .dropdown-menu').stop(true, false).slideUp();
        $('.header-v7 .dropdown').removeClass('open');

        if ($(this).siblings('.dropdown-menu').is(":hidden") == true) {
          $(this).siblings('.dropdown-menu').stop(true, false).slideDown();
          $(this).parents('.dropdown').addClass('open');
        }
      });
    }

    SidebarMenuDropdown();
  },

  //Animate Dropdown
  initAnimateDropdown: function () {
    function MenuMode() {
      $('.dropdown').on('show.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
      });
      $('.dropdown').on('hide.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
      });
    }

    $(window).resize(function () {
      if ($(window).width() > 768) {
        MenuMode();
      }
    });

    if ($(window).width() > 768) {
      MenuMode();
    }
  },
  componentDidMount: function () {

    this.handleBootstrap();
    this.handleTopBar();
    this.handleTopBarSubMenu();
    this.handleToggle();
    this.handleHeader();
    this.handleMegaMenu();
    this.handleHoverSelector();
    this.handleFullscreen();
    this.handleValignMiddle();
    this.handleEqualHeightColumns();

  },

  getInitialState: function () {

    var imgPath;

    if (this.props.locale == 'es')
      imgPath = 'img/bfgFlagEn.png';
    else
      imgPath = "img/bfgFlagEs.png";

    return {
      locale: this.props.locale, img: imgPath
    }
  },

  handleLocaleChange: function (event) {
    event.preventDefault();

    var language;
    var image;

    if (this.props.locale == 'en') {
      language = 'es';
      image = "img/bfgFlagEn.png"
    }
    else {
      language = 'en';
      image = "img/bfgFlagEs.png"
    }

    this.setState({
      locale: language,
      img: image
    });

    this.props.onLocalChange(language);
  },
  render() {
    return <div>
      <div className="blog-topbar">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 col-xs-8 col-lg-8">
              <div className="topbar-toggler"><span className="fa fa-angle-down"></span></div>
              <ul className="topbar-list topbar-menu">
                <li><Link to="/aboutBarri" activeClassName="active"><FormatMessage
                  locale={this.props.locale} path="menu/menuBarri" /></Link></li>
                <li><Link to="/clientService" activeClassName="active"><FormatMessage
                  locale={this.props.locale} path="menu/menuCustomerService" /></Link></li>
                <li><Link to="/locations" activeClassName="active"><FormatMessage
                  locale={this.props.locale} path="menu/menuLocations" /></Link></li>
                <li><Link to="/employment" activeClassName="active"><FormatMessage
                  locale={this.props.locale} path="menu/menuCarrers" /></Link></li>
                <li><Link to="/agent" activeClassName="active"><FormatMessage locale={this.props.locale}
                  path="menu/menuAgent" /></Link>
                </li>
                <li>
                  <Link to="/promotions" activeClassName="active">
                    <FormatMessage locale={this.props.locale} path="menu/menuPromotionsLink" />
                  </Link>
                </li>
                <li>
                  <Link to="/covid19" activeClassName="active">
                    COVID-19
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-sm-6 col-xs-4 col-lg-4 clearfix">

              {/* <Link to="/" activeClassName="active cd-log_reg" onClick={this.handleLocaleChange}><img
                className="img-rounded pull-right" src={this.state.img} /></Link> */}

              <Link to="/" activeClassName="active cd-log_reg"
                className="pull-right" onClick={this.handleLocaleChange}
                id="languageLink"
              >
                <i className="fa fa-globe fa-lg" aria-hidden="true"></i>
                <span>{this.props.locale == "es" ? "EN" : "ES"}</span>
              </Link>

              <ul className="topbar-list topbar-log_reg pull-right visible-sm-block visible-md-block visible-lg-block">
                <li><a className="cd-log_reg home" href="https://www.barrimoneytransfer.com/mb/login"
                  target="_blank"><FormatMessage locale={this.props.locale} path="menu/menuLogin" /></a>
                </li>
                <li><a className="cd-log_reg" href="https://twitter.com/BarriGroup"
                  target="_blank"><span className="fa fa-twitter"></span></a></li>
                <li><a className="cd-log_reg" href="https://www.facebook.com/Barrigroup/"
                  target="_blank"><span className="fa fa-facebook"></span> </a></li>
                <li><a className="cd-log_reg"
                  href="https://www.linkedin.com/company/barri-financial-group"
                  target="_blank"><span className="fa fa-linkedin"></span> </a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="navbar mega-menu " role="navigation">
        <div className="container-fluid">
          <div className="res-container">
            <button type="button" className="navbar-toggle" data-toggle="collapse"
              data-target=".navbar-responsive-collapse">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <div className="navbar-brand"><a href="/"><img style={{ backgroundColor : "#0062a1", paddingLeft : 7, paddingRight: 7 }} className="img-responsive barriLogo"
              src="img/bfgLogo.png" alt="Logo" /></a></div>
          </div>
          <div className="collapse navbar-collapse navbar-responsive-collapse">
            <div className="res-container">
              <ul className="nav navbar-nav">
                <li><Link to="/sendMoney" activeClassName="active"><FormatMessage
                  locale={this.props.locale} path="menu/menuSendMoney" /></Link></li>

                <li><Link to="/checkCashing" activeClassName="active"><FormatMessage
                  locale={this.props.locale} path="menu/menuCheckCashing" /></Link></li>

                <li><Link to="/paymentServices" activeClassName="active"><FormatMessage
                  locale={this.props.locale} path="menu/menuBillPayment" /></Link></li>

                <li><Link to="/reloadCell" activeClassName="active"><FormatMessage
                  locale={this.props.locale} path="menu/menuMobileRecharge" /> </Link></li>

                <li><Link to="/loans" activeClassName="active"><FormatMessage locale={this.props.locale}
                  path="menu/menuLoans" /></Link>
                </li>

                <li><Link to="/otherServices" activeClassName="active"><FormatMessage
                  locale={this.props.locale} path="menu/menuOtherServices" /></Link></li>


                {/* <li><Link to="/insurance" activeClassName="active"><FormatMessage
                  locale={this.props.locale} path="menu/menuCarInsurance" /></Link></li>*/}


              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
  }
})

module.exports = BfgNavBar



// WEBPACK FOOTER //
// ./js/navBar.js